// extracted by mini-css-extract-plugin
export default {"label":"ImageInput_label__0z54h","labelWithIcon":"ImageInput_labelWithIcon__iz0oe"};